import React from "react";
import { Route, Routes } from "react-router-dom";

import SkuDetailsPage from "@/components/screens/SkuDetailsPage";
import SkuFormPage from "@/components/screens/SkuFormPage";
import { SKU_DETAILS_MESSAGES } from "@/messages/sku/sku-details.messages";
import { SKU_FORM_MESSAGES } from "@/messages/sku/sku-form.messages";

const SkuPage: React.FC = () => {
  return (
    <Routes>
      <Route
        path="/details/:productId/:skuId/:lang"
        element={<SkuDetailsPage messages={SKU_DETAILS_MESSAGES} />}
      />
      <Route
        path="/create/:productId/:productCode/:lang"
        element={<SkuFormPage messages={SKU_FORM_MESSAGES} />}
      />
      <Route
        path="/details/:productId/:skuId"
        element={<SkuDetailsPage messages={SKU_DETAILS_MESSAGES} />}
      />
      <Route
        path="/create/:productId/:productCode"
        element={<SkuFormPage messages={SKU_FORM_MESSAGES} />}
      />
    </Routes>
  );
};

export default SkuPage;
